/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileNewsletterSettings } from '../../models/profile-newsletter-settings';

export interface GetNewsletterChangeSettings$Params {
  id: number;
}

export function getNewsletterChangeSettings(http: HttpClient, rootUrl: string, params: GetNewsletterChangeSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileNewsletterSettings>> {
  const rb = new RequestBuilder(rootUrl, getNewsletterChangeSettings.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProfileNewsletterSettings>;
    })
  );
}

getNewsletterChangeSettings.PATH = '/rest/profile/{id}/newsletter/settings';
